import { Yup, TRANSLATION } from "@/imports-files/pages/clients/company/add-members";

export const COMMUNICATIONS = {
                               
                                action_options: {
                                                    mark_as_read: { 
                                                                      title: 'Mark As Read'
                                                                  },
                                                    mark_as_unread:{
                                                                      title: 'Mark As Unread'
                                                                   },
                                                    dismiss:{
                                                              title: 'Delete'
                                                            }
                                                },
                                email_action_options: {
                                                    reply_all: { 
                                                                      title: 'Reply All'
                                                                  },
                                                    forward:{
                                                                      title: 'Forward'
                                                                   },
                                                    delete:{
                                                              title: 'Delete'
                                                            }
                                                }
                              }